import React, { Component } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Link from '../Link';
import YoutubeVideoEmbed from '../YoutubeVideoEmbed';

import './VideoCard.scss';

class VideoCard extends Component {
  // static defaultProps = {}
  constructor(props) {
    super(props)
    this.state = {
      videoId: null
    }
  }

  isValidHttpUrl = (string) => {
    let url;
    
    try {
      url = new URL(string);
    } catch (_) {
      return false;  
    }
  
    return url.protocol === "http:" || url.protocol === "https:";
  }

  render() {
    const baseClassName = 'pb-video-card';
    const {
      parentClassName,
      videoId,
      title,
      description,
      hasOverlay,
      onClick,
      isRtl,
      ytLockSVG,
      aspectRatio,
      autoPlay,
      mute
    } = this.props;

    const classes = {
      [baseClassName]: true,
      [`${baseClassName}--rtl`]: isRtl,
      [parentClassName]: parentClassName
    };

    let url = this.isValidHttpUrl(videoId) ? new URL(videoId) : "";
    let id = url ? url.searchParams.get('v') : null;

    return (
      <div className={classNames(classes)} >
        <YoutubeVideoEmbed videoId={id} ytLockSVG = {ytLockSVG} aspectRatio={aspectRatio} autoPlay={autoPlay} mute={mute}/>
        {title && <h3 className={`${baseClassName}__title`}>{title}</h3>}
        {description && <p className={`${baseClassName}__desc`}>{description}</p>}
        {hasOverlay && <Link noSitelLocale parentClassName={`${baseClassName}__link`} 
          onClick={onClick}> 
        </Link>}
      </div>
    );
  }
}

VideoCard.propTypes = {
  parentClassName: PropTypes.string
};

export default VideoCard;



// WEBPACK FOOTER //
// ./src/components/VideoCard/VideoCard.jsx